<script setup lang="ts">
</script>

<template>
  <div class="border-t border-black-90"></div>
</template>

<style scoped>
</style>
